import { Helmet } from 'react-helmet-async'

const SEO = ({ 
  title, 
  description, 
  canonical, 
  ogImage = '/og-image.jpg',
  ogType = 'website',
  structuredData,
  keywords 
}) => {
  const fullTitle = title ? `${title} | Estudio Contable Vanesa Mondejar` : 'Estudio Contable Vanesa Mondejar - Servicios Contables Profesionales'
  const fullDescription = description || 'Estudio contable profesional especializado en servicios contables, impositivos y asesoramiento empresarial. Más de 10 años de experiencia.'
  
  // Keywords por defecto optimizadas para búsquedas
  const defaultKeywords = [
    'estudio contable',
    'vanesa mondejar',
    'estudio contable vanesa mondejar',
    'contador',
    'contadora',
    'servicios contables',
    'asesoramiento impositivo',
    'liquidacion de sueldos',
    'consultoria empresarial',
    'contabilidad general',
    'auditoria',
    'estudio contable argentina',
    'contador publico',
    'servicios contables profesionales'
  ]
  
  const seoKeywords = keywords || defaultKeywords.join(', ')
  
  // Construir URL absoluta para og-image
  const getAbsoluteUrl = (path) => {
    if (typeof window === 'undefined') return path
    if (path.startsWith('http://') || path.startsWith('https://')) return path
    const origin = window.location.origin
    return `${origin}${path}`
  }
  
  const absoluteOgImage = getAbsoluteUrl(ogImage)
  const absoluteCanonical = canonical || (typeof window !== 'undefined' ? window.location.href : '')

  return (
    <Helmet>
      {/* Meta básicas */}
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      <meta name="keywords" content={seoKeywords} />
      <meta name="author" content="Vanesa Mondejar" />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <link rel="canonical" href={absoluteCanonical} />
      
      {/* Geo tags */}
      <meta name="geo.region" content="AR" />
      <meta name="geo.placename" content="Argentina" />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:image" content={absoluteOgImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={absoluteCanonical} />
      <meta property="og:site_name" content="Estudio Contable Vanesa Mondejar" />
      <meta property="og:locale" content="es_AR" />
      
      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      <meta name="twitter:image" content={absoluteOgImage} />
      
      {/* JSON-LD Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  )
}

export default SEO
